import mitt from 'mitt'

// Vue2/Vue3 どちらでも差し替えやすいように、singleton emitter をexportする
export const emitter = mitt()

/**
 * global-var 8123–10875 付近の `emitGlobalVarPopupDialog` が発火するイベント名一覧（上から順に emitter.js 内で grep 可能）。
 * 購読: 各ダイアログは wrapMittPopupHandler + this.$emitter.on（$eventHub.$on は廃止）。
 * レガシー発火: 未移行の this.$eventHub.$emit('open-…-dialog', …) は installLegacyEventHubGlobalVarPopupForwardToMitt で mitt に転送される。
 */
export const GLOBAL_VAR_POPUP_EVENT_TYPES = Object.freeze([
  'open-adtop-dialog',
  'open-agrinavi-dialog',
  'open-asiro-dialog',
  'open-baton-dialog',
  'open-bizreach-dialog',
  'open-bridge-dialog',
  'open-capla-dialog',
  'open-careerdraft-dialog',
  'open-dely-dialog',
  'open-growtrail-dialog',
  'open-hitotech-dialog',
  'open-hitotechneocareer-dialog',
  'open-hrcareer-dialog',
  'open-jaic-dialog',
  'open-jigen-dialog',
  'open-jobs919-dialog',
  'open-kirara-dialog',
  'open-krasys-dialog',
  'open-medley-dialog',
  'open-miraiyu-dialog',
  'open-mynavi-dialog',
  'open-mynavi-ms-dialog',
  'open-neocareer-dialog',
  'open-new-rt-system-dialog',
  'open-peacekaigo-dialog',
  'open-persolinnovation-dialog',
  'open-pleiades-dialog',
  'open-realtimetransfercommon-dialog',
  'open-reastage-dialog',
  'open-recree-dialog',
  'open-recruit_mc-dialog',
  'open-roxx-dialog',
  'open-rozas-dialog',
  'open-simple-dialog',
  'open-systemshared-dialog',
  'open-techouse-dialog',
  'open-tryt-dialog',
  'open-tunaguba-dialog',
  'open-usenworking-dialog',
  'open-workgate-popup-dialog',
  'open-workport-dialog',
  'open-xmile-dialog',
  'open-yagish-dialog'
])

const GLOBAL_VAR_POPUP_EVENT_SET = new Set(GLOBAL_VAR_POPUP_EVENT_TYPES)

/**
 * emitGlobalVarPopupDialog が emit する配列ペイロードを、既存の open メソッドへ渡す mitt 用ラッパー。
 * 登録: this.$emitter.on(ev, wrapMittPopupHandler(this, 'openFoo'))
 * 解除: this.$emitter.off(ev, this._mittXXX) ※ on に渡したのと同一参照が必要
 */
export function wrapMittPopupHandler (vm, methodName) {
  return function globalVarPopupMittForward (argList) {
    const fn = vm[methodName]
    if (typeof fn !== 'function') return
    fn.apply(vm, Array.isArray(argList) ? argList : [])
  }
}

/**
 * mitt では第2引数が1つだけのため、可変長引数は配列で渡す。
 */
export function emitGlobalVarPopupDialog (type, ...args) {
  if (!GLOBAL_VAR_POPUP_EVENT_SET.has(type)) {
    throw new Error(`emitGlobalVarPopupDialog: unknown event "${type}"`)
  }
  emitter.emit(type, args)
}

let legacyHubPopupForwardInstalled = false

/**
 * まだ this.$eventHub.$emit('open-…-dialog', …) のままの呼び出しを mitt 購読側へ届ける（一方向: hub → mitt）。
 * emitGlobalVarPopupDialog は hub を経由しないため二重発火しない。
 */
export function installLegacyEventHubGlobalVarPopupForwardToMitt (Vue) {
  if (legacyHubPopupForwardInstalled) {
    return
  }
  const hub = Vue.prototype.$eventHub
  if (!hub) {
    return
  }
  for (const ev of GLOBAL_VAR_POPUP_EVENT_TYPES) {
    hub.$on(ev, function legacyHubGlobalVarPopupForward (...args) {
      emitter.emit(ev, args)
    })
  }
  legacyHubPopupForwardInstalled = true
}

/** RT を未送信で閉じたときのチェーン用（旧 $eventHub 名と同一文字列） */
export const RT_DIALOG_CLOSED_WITHOUT_SUBMIT = 'realtimetransfer-dialog-closed-without-submit'

export function emitRtDialogClosedWithoutSubmit () {
  emitter.emit(RT_DIALOG_CLOSED_WITHOUT_SUBMIT)
}

const EmitterPlugin = {
  install: function (Vue) {
    Vue.prototype.$emitter = emitter
    installLegacyEventHubGlobalVarPopupForwardToMitt(Vue)
  }
}

export default EmitterPlugin
